module.exports = __webpack_public_path__ + "img/icon_exchange_title.b60aafcb.png";